export default __webpack_public_path__ + "static/media/gridNormal.abdeceb9.png";